module.exports = __webpack_public_path__ + "ceda8614bca4e53d7aafe8559460020f.pdf";